import { CrudApiService } from '../utilities/crud.api.service';
import { ICrudApiService } from '../utilities/types';

export interface INewAccountCheckResponse {
  isNewAccount: boolean;
}

class NewAccountCheckApiService implements ICrudApiService<INewAccountCheckResponse> {
  crudApiService = new CrudApiService<INewAccountCheckResponse>();

  urls = {
    resource: () => `/app/sub-accounts/is-new`,
  };

  /**
   * Checks if the sub-account's owner is considered a "new account".
   * @returns A promise that resolves to an object containing a boolean `isNewAccount`.
   */
  checkNewAccount = (): Promise<INewAccountCheckResponse> => this.crudApiService.get(this.urls.resource());
}

export const newAccountCheckApiService = new NewAccountCheckApiService();
